import React, { useState } from 'react';
import { X } from 'lucide-react';
import { beforeAfterGallery } from '../data/mock';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (item) => {
    setSelectedImage(item);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <section id="gallery" className="py-24 bg-page">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-4">Galería de Tratamientos</h2>
          <p className="body-large text-secondary max-w-2xl mx-auto">
            Resultados reales de tratamientos dermatológicos realizados por el Dr. Adrián Cuéllar Barboza.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="voice-grid">
          {beforeAfterGallery.map((item, index) => {
            const accentClasses = ['accent-purple', 'accent-blue', 'accent-orange', 'accent-pink', 'accent-green'];
            const accentClass = accentClasses[index % accentClasses.length];
            
            return (
              <div 
                key={item.id} 
                className={`voice-card ${accentClass} hover-lift cursor-pointer`}
                onClick={() => openModal(item)}
              >
                {/* Treatment Title */}
                <h3 className="voice-card-title mb-4 text-center">{item.treatment}</h3>

                {/* Treatment Image */}
                <div className="relative overflow-hidden rounded-lg">
                  <img 
                    src={item.image} 
                    alt={item.treatment}
                    className="w-full h-64 object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
              </div>
            );
          })}
        </div>

        {/* Disclaimer */}
        <div className="text-center mt-12">
          <p className="caption max-w-2xl mx-auto">
            *Los resultados pueden variar de persona a persona. Las imágenes mostradas son de casos reales tratados por el Dr. Adrián Cuéllar Barboza.
          </p>
        </div>
      </div>

      {/* Modal - Click to view full size */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4" onClick={closeModal}>
          <div className="relative max-w-4xl max-h-[90vh]">
            <button 
              onClick={closeModal}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors"
            >
              <X size={32} />
            </button>
            <img 
              src={selectedImage.image}
              alt={selectedImage.treatment}
              className="w-full h-auto rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-white/90 px-4 py-2 rounded-lg font-medium text-sm">
                {selectedImage.treatment}
              </span>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;